<template>
  <div id="RemoteHands">
    <div class="thred">
      <MyHeaderPage
        :title="$t('help.detailTitle', { ticket_id: ticket.ticketNumber })"
      />
      <TicketsBackLink />
      <div class="contentFormTwoCol">
        <div class="contentPrimary boxRhDetails relative">
          <div class="pdf-download-button">
            <button
              class="cdlButtonGreen pdf-button"
              @click="downloadPdf">
              <DownloadPdf class="download-icon" />
              <span>{{ $t("remoteHands.downloadPdf") }}</span>
            </button>
          </div>
          <div class="mdl-grid alignItems">
            <div class="mdl-cell mdl-cell--2-col">
              <img src="@/assets/img/icon_info.png" alt="location" width="45" />
            </div>
            <div class="mdl-cell mdl-cell--10-col">
              <span class="label">{{ $t("tickets.attivazioni_tlc") }}</span>
            </div>
            <div class="mdl-cell mdl-cell--12-col">
              <hr />
            </div>


            <slot name="colocation-category"></slot>

            <div class="mdl-cell mdl-cell--2-col">
              <img src="@/assets/img/icon_reference.png" alt="reference" width="45" />
            </div>
            <div class="mdl-cell mdl-cell--10-col">
              <div>
                <span class="label">{{ $t("help.emailRef") }}</span>
                <span
                  v-if="ticket.cf_list?.cf_email_referente"
                  class="text"
                  style="margin-left: 3px"
                  >{{ ticket.cf_list.cf_email_referente }}</span
                >
                <span v-else class="text" style="margin-left: 3px">{{
                  userStore.user?.email
                }}</span>
              </div>
            </div>
            <div class="mdl-cell mdl-cell--12-col">
              <hr />
            </div>
          </div>
        </div>
        <div class="contentSecondary noPadding minHeightThreads">
          <Threads
            :headers="headerThread"
            :ticket="ticket"
            :threads="threads"
            :attachs="attachs"
            @update="getThreads"
          />
        </div>
      </div>

      <MyLoading :viewLoader="viewLoader" type="full" />
    </div>
  </div>
</template>

<script>
import Threads from "@/components/Threads.vue";
import MyLoading from "@/components/MyLoading.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import TicketsBackLink from "@/components/Tickets/BackLink.vue";
import DownloadPdf from "@/components/svg/DownloadPdf.vue";
import { useUserStore } from "@/stores/UserStore";
import "@/assets/scss/Solutions.scss";

export default {
  name: "ActivationDetails",
  components: {
    Threads,
    MyHeaderPage,
    MyLoading,
    TicketsBackLink,
    DownloadPdf
  },
  data() {
    return {
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      ticket: {},
      threads: {},
      attachs: {},
      headerThread: {
        createdTime: "###",
        modifiedTime: "###",
      },
      viewLoader: true,
      viewError: false,
      userStore: {},
    };
  },
  methods: {
    getEntity(entityId) {
      this.viewLoader = false;
      const URL = `tickets/v1/ticket/?ticket_id=${this.$route.params.id}&ticket_type=Incident`;

      if (entityId) {
        this.axios
          .get(window.VUE_APP_MISTRA_URL + URL, {
            headers: this.he,
          })
          .then((response) => {
            this.ticket = response.data.res;
            for (const [key, value] of Object.entries(this.ticket)) {
              if (
                Object.prototype.hasOwnProperty.call(this.headerThread, key)
              ) {
                this.headerThread[key] = value;
              }
            }
            if (response.data) {
              this.ticket = response.data.res;
            }
          })
          .then(() => {
            this.viewLoader = true;
            this.getThreads();
          })
          .catch(function (err) {
            self.viewSubmit = true;
            self.viewError = true;
            self.messageError = err.response.data.message;
          });
      }
    },
    getThreads() {
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "tickets/v1/ticket-threads-by-ticket-number/?ticket_number=" +
            this.$route.params.id,
          { headers: this.he }
        )
        .then((response) => {
          this.threads = response.data;
          if (response.data.threadAttachments) {
            this.attachs = response.data.threadAttachments;
          }
          this.viewLoader = true;
        });
    },
    downloadPdf() {
      this.axios
          .get(`
            ${window.VUE_APP_MISTRA_URL}tickets/v1/ticket/pdf?ticket_id=${this.$route.params.id}&ticket_type=CrossConnect`, 
            {
              headers: this.he,
              responseType: "blob",
            }
          )
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `ticket_${this.ticket.ticketNumber}.pdf`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.isLoading = false;
          })
          .catch((error) => {
            console.error("Error downloading PDF:", error);
            this.isLoading = false;
          });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getEntity(this.$route.params.id);
    this.userStore = useUserStore();
  },
  beforeUpdate() {
    this.$IsLoggedIn();
  },
};
</script>

<style scope>
#contentThreads .table {
  display: table;
  box-shadow: none;
  width: 98%;
  border-spacing: 0;
  margin: 0 auto;
  border-radius: 10px;
  background-color: white;
  margin-bottom: 20px;
}
#contentThreads .table th {
  padding-left: 0;
}
#contentThreads .table tr, #contentThreads .table td  {
  padding: 10px 0 !important;
  border-bottom: 1px solid #002e5f;
}

#contentThreads .container h5 {
  padding-left: 10px;
}

.pdf-download-button {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
}

.pdf-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px !important;
  border-radius: 20px;
  font-size: 14px !important;
  width: auto;
}

.download-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.download-icon path {
  fill: white;
}

.relative {
  position: relative;
}
</style>
